import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetMembershipMessages } from './messages';

export interface useGetMembershipOptions {
  shouldFetch?: boolean;
}

export function useGetMembership(
  membershipId: number | null | undefined,
  options?: useGetMembershipOptions,
) {
  const mergedOptions: useGetMembershipOptions = {
    shouldFetch: true,
    ...options,
  };

  const { membershipApi } = usePrivate();

  const results = useSWR(
    membershipApi && mergedOptions.shouldFetch
      ? `/api/Membership/${membershipId}`
      : null,
    () => membershipApi?.apiMembershipGet(membershipId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetMembershipMessages['useGetMembership.fetch.unexpectedError'],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetMembership> error fetching membership.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !membershipApi;

  return { ...results, isLoadingOrValidating };
}
